import { connect } from "react-redux";
import AdminAccessPage from "../components/admin-access/AdminAccessPage";

const mapStateToProps = (state) => ({
  catalog: state.catalogReducer,
});

export default connect(mapStateToProps)(AdminAccessPage);
